// Handle radio button behavior for filter checkboxes
let checkboxFilters = document.querySelectorAll('.search_filters .search_filter input');
checkboxFilters.forEach(function (filter) {
  filter.addEventListener('change', function () {
    if (filter.checked == false) {
      return;
    }
    checkboxFilters.forEach(function (checkbox) {
      if (filter !== checkbox && checkbox.checked == true) {
        checkbox.checked = false;
      }
    });
  });
});

// Add translations for the store locator page
document.addEventListener('DOMContentLoaded', function () {
  function updateTextContent(selector, text) {
    let element = document.querySelector(selector);
    if (element) {
      element.textContent = text;
    }
  }
  function updateOptionsText(selectId, oldText, newText) {
    let selectElement = document.getElementById(selectId);
    if (selectElement) {
      let options = Array.from(selectElement.options);
      options.forEach(function (option) {
        if (option.text === oldText) {
          option.text = newText;
        }
      });
    }
  }
  function updateFilterLabels() {
    let filterLabels = document.querySelectorAll('.search_filters .search_filter label');
    if (filterLabels.length > 0) {
      filterLabels.forEach(function (label) {
        switch (label.textContent.trim()) {
          case 'Boutiques Pequignet':
            label.textContent = storeLocatorTranslations.filters_label.pequignet_stores;
            break;
          case 'Grands Magasins':
            label.textContent = storeLocatorTranslations.filters_label.department_stores;
            break;
          case 'Revendeurs':
            label.textContent = storeLocatorTranslations.filters_label.retailers;
            break;
        }
      });
    }
  }
  function updatePhoneElements() {
    let phoneElements = document.querySelectorAll('li p');
    phoneElements.forEach(function (p) {
      if (p.textContent.includes('Téléphone')) {
        p.innerHTML = p.innerHTML.replace('Téléphone', storeLocatorTranslations.store_list.phone);
      }
    });
  }
  updateTextContent('.main_search_label', storeLocatorTranslations.search_label.location);
  updateTextContent('.distance_label', storeLocatorTranslations.search_label.distance);
  updateOptionsText('within_distance', 'Pas de limite', storeLocatorTranslations.search_label.no_limit);
  updateTextContent('.search_limit_label', storeLocatorTranslations.search_label.number_of_results);
  updateTextContent('#submitBtn', storeLocatorTranslations.search_label.search);
  updateFilterLabels();
  updatePhoneElements();
});